import { Map as ImmutableMap, Record } from 'immutable';
const SiteSettingsRecord = Record({
  membershipRegistrationFollowUpSettings: null,
  bodyOverrideByDomain: ImmutableMap()
});
const DomainSettingsRecord = Record({
  membershipSsoEnabled: null,
  membershipJwtEnabled: null,
  membershipRegistrationFollowUpSettings: null
});
SiteSettingsRecord.fromJS = attrs => {
  const bodyOverrideByDomain = Object.keys(attrs.bodyOverrideByDomain).reduce((domainSettings, domain) => domainSettings.set(domain, new DomainSettingsRecord(attrs.bodyOverrideByDomain[domain])), ImmutableMap());
  return new SiteSettingsRecord({
    bodyOverrideByDomain,
    membershipRegistrationFollowUpSettings: attrs.membershipRegistrationFollowUpSettings
  });
};
export default SiteSettingsRecord;